module.exports = __webpack_public_path__ + "img/anatel.4d569ad4.png";